import { platform } from "@/lib/capacitor"
import { api } from "@/services/api"

export async function registerDeviceToken(token: string) {
  return api.post("/notifications/devices", { token, platform })
}

export async function unregisterDeviceToken(token: string) {
  return api.delete("/notifications/devices", { data: { token } })
}
